module.exports = __webpack_public_path__ + "assets/img/tab2_04.e048fd9c.jpg";